// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {http} from '@app/features/platform/transport/RestTransport';
import type {AvatarDecorationCatalogResponse} from '@fluxer/schema/src/domains/user/AvatarDecorationSchemas';

export async function fetchAvatarDecorationCatalog(): Promise<AvatarDecorationCatalogResponse> {
	const response = await http.get<AvatarDecorationCatalogResponse>(Endpoints.AVATAR_DECORATIONS);
	return response.body;
}
